import cn from 'classnames';
import {FC} from 'react';
import {MY_TAX_ACCESS_QR_CAPTION, MY_TAX_ACCESS_QR_SRC} from '../../../model';
import styles from './MyTaxQrBlock.module.css';

type Props = {
	variant?: 'access' | 'error';
};

export const MyTaxQrBlock: FC<Props> = ({variant = 'access'}) => {
	return (
		<div className={cn(styles.block, variant === 'error' && styles.block_error)}>
			<div className={styles.container}>
				<img className={styles.qrImage} src={MY_TAX_ACCESS_QR_SRC} alt="" />
				<p className={styles.qrCaption}>{MY_TAX_ACCESS_QR_CAPTION}</p>
			</div>
		</div>
	);
};
